<template>
  <v-container class="contact-page">
    <div>
      <div class="bg-fixed-100" :style="{ backgroundImage: 'url(' + contactBg + ')' }"></div>

      <router-link :to="{ name: 'Home'}">
      <img :src="$root.logo" class="main-logo big">
    </router-link>
    <div class="contact">

      <iconClose @click="onClose" class="icon-close"></iconClose>
      <contact-form></contact-form>
    </div>
    </div>
  </v-container>
</template>

<script>
import Viewport from '@monogrid/vue-lib/lib/mixins/Viewport'
import contactBg from '@/assets/img/contact-bg.jpg'
import iconClose from '@/assets/svg/cross-icon.svg'
import aboutTexture from '@/assets/img/about-texture.jpg'
import ContactForm from '../molecules/ContactForm.vue'

export default {
  name: 'Contact',

  mixins: [Viewport],

  components: {
    iconClose,
    ContactForm
  },
  data () {
    return {
      contactBg,
      aboutTexture,
      name: '',
      message: '',
      address: '',
      email: '',
      phone: '',
      response: '',
      success: ''
    }
  },

  methods: {
    onClose () {
      this.$router.push({ name: 'Home' })
    }
  },

  watch: {
  },

  metaInfo: function () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.contact-page {
  text-align: center;
}

.contact {
  position: absolute;
  width: 60%;
  padding: 40px;
  margin: auto;
  top: 30%;
  left: 20%;

  @include breakpoint('xs-only') {
    width: 100%;
    left: 0;
  }

}

.icon-close {
  float: right;
  z-index: 2;
  position: absolute;
  right: 0;
  top: 0;
}

.home-title {
  position: relative;
  margin-top: 0;
  padding: 10px 40px;
  color: $c-red;
  text-align: center;

  h1,
  h4 {
    font-weight: 500;
  }

  h1 {
    margin-top: -40px;

    @include breakpoint('xs-only') {
      margin-top: 0;
    }
  }
}
</style>
